import { render, staticRenderFns } from "./UpdateTags.vue?vue&type=template&id=943ffc58&"
import script from "./UpdateTags.vue?vue&type=script&lang=js&"
export * from "./UpdateTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports